module.exports = __webpack_public_path__ + "static/img/1.29a78dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner3/1.png
// module id = zrrl
// module chunks = 14